type IArquivos = {
    arquivo: any;
    nome: string;
};

type ISubPasta = {
    titleSubPasta: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};

type IMaterial = {
    isPaste?: boolean;
    titlePaste?: string;
    arquivos?: IArquivos[];
    subPastas?: ISubPasta[];
};
type TItem = {
    title: string;
    materiais: IMaterial[];
};

export const ListMateriaisCircuitoPrivatePlanoAnual: TItem[] = [
    {
        title: 'Cadernos',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'CadForm_AlfabetizacaoInicial_agenda1',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_AlfabetizacaoInicial_agenda1.pdf',
                    },
                    {
                        nome: 'CadForm_AlfabetizacaoInicial_agenda2',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_AlfabetizacaoInicial_agenda2.pdf',
                    },
                    {
                        nome: 'CadForm_AlfabetizacaoInicial_agenda3',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_AlfabetizacaoInicial_agenda3.pdf',
                    },
                    {
                        nome: 'CadForm_AlfabetizacaoInicial_agenda4',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_AlfabetizacaoInicial_agenda4.pdf',
                    },
                    {
                        nome: 'CadForm_LetramentoCientifico_agenda1',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LetramentoCientifico_agenda1.pdf',
                    },
                    {
                        nome: 'CadForm_LetramentoCientifico_agenda2',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LetramentoCientifico_agenda2.pdf',
                    },
                    {
                        nome: 'CadForm_LinguagemArtistica_agenda1',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguagemArtistica_agenda1.pdf',
                    },
                    {
                        nome: 'CadForm_LinguagemCorporal_agenda1',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguagemCorporal_agenda1.pdf',
                    },
                    {
                        nome: 'CadForm_LinguagemCorporal_agenda2',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguagemCorporal_agenda2.pdf',
                    },
                    {
                        nome: 'CadForm_LinguagemDigital_agenda',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguagemDigital_agenda.pdf',
                    },
                    {
                        nome: 'CadForm_LinguaPortuguesa_agenda1',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguaPortuguesa_agenda1.pdf',
                    },
                    {
                        nome: 'CadForm_LinguaPortuguesa_agenda2',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguaPortuguesa_agenda2.pdf',
                    },
                    {
                        nome: 'CadForm_LinguaPortuguesa_agenda3',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguaPortuguesa_agenda3.pdf',
                    },
                    {
                        nome: 'CadForm_LinguaPortuguesa_agenda4',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_LinguaPortuguesa_agenda4.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda1',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_Matematica_agenda1.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda2',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_Matematica_agenda2.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda3',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_Matematica_agenda3.pdf',
                    },
                    {
                        nome: 'CadForm_Matematica_agenda4',
                        arquivo: 'CIRCUITO_Materiais_2026/CADERNOS/CadForm_Matematica_agenda4.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Experimentos',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Guia de Experimento_Circuito 360',
                        arquivo: 'CIRCUITO_Materiais_2026/EXPERIMENTOS/Guia de Experimento_Circuito 360.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Guias e Fascículos',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Circuito 360 - Guia de implantação e implementação',
                        arquivo: 'CIRCUITO_Materiais_2026/GUIAS E FASCÍCULOS/Circuito 360 - Guia de implantação e implementação.pdf',
                    },
                    {
                        nome: 'Circuito 360 - Visao Geral',
                        arquivo: 'CIRCUITO_Materiais_2026/GUIAS E FASCÍCULOS/Circuito 360 - Visao Geral.pdf',
                    },
                    {
                        nome: 'Fasciculo_1_Circuito360_Apresentacao_Geral',
                        arquivo: 'CIRCUITO_Materiais_2026/GUIAS E FASCÍCULOS/Fasciculo_1_Circuito360_Apresentacao_Geral.pdf',
                    },
                    {
                        nome: 'Fasciculo_2_Circuito360',
                        arquivo: 'CIRCUITO_Materiais_2026/GUIAS E FASCÍCULOS/Fasciculo_2_Circuito360.pdf',
                    },
                    {
                        nome: 'Fasciculo_3_Circuito360',
                        arquivo: 'CIRCUITO_Materiais_2026/GUIAS E FASCÍCULOS/Fasciculo_3_Circuito360.pdf',
                    },
                    {
                        nome: 'Modelo Formativo Circuito 360',
                        arquivo: 'CIRCUITO_Materiais_2026/GUIAS E FASCÍCULOS/Modelo Formativo Circuito 360.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Projetos Integradores',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Atividades_Integradoras_1_Lingua_Portuguesa',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_1_Lingua_Portuguesa.pdf',
                    },
                    {
                        nome: 'Atividades_Integradoras_2_Matematica',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_2_Matematica.pdf',
                    },
                    {
                        nome: 'Atividades_Integradoras_3_Ciencias',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_3_Ciencias.pdf',
                    },
                    {
                        nome: 'Atividades_Integradoras_4_Arte',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_4_Arte.pdf',
                    },
                    {
                        nome: 'Atividades_Integradoras_5_LinguagemCorporal',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_5_LinguagemCorporal.pdf',
                    },
                    {
                        nome: 'Atividades_Integradoras_6_Etica_e_CidadaniaDigital',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_6_Etica_e_CidadaniaDigital.pdf',
                    },
                    {
                        nome: 'Atividades_Integradoras_7_Historia_Geografia',
                        arquivo: 'CIRCUITO_Materiais_2026/PROJETOS INTEGRADORES/Atividades_Integradoras_7_Historia_Geografia.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Proposta Didática',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'C360-1ºANO-PROPOSTA DIDÁTICA',
                        arquivo: 'CIRCUITO_Materiais_2026/PROPOSTA DIDÁTICA/C360-1ºANO-PROPOSTA DIDÁTICA.pdf',
                    },
                    {
                        nome: 'C360-2ºANO-PROPOSTA DIDÁTICA',
                        arquivo: 'CIRCUITO_Materiais_2026/PROPOSTA DIDÁTICA/C360-2ºANO-PROPOSTA DIDÁTICA.pdf',
                    },
                    {
                        nome: 'C360-3ºANO-PROPOSTA DIDÁTICA',
                        arquivo: 'CIRCUITO_Materiais_2026/PROPOSTA DIDÁTICA/C360-3ºANO-PROPOSTA DIDÁTICA.pdf',
                    },
                    {
                        nome: 'C360-4ºANO-PROPOSTA DIDÁTICA',
                        arquivo: 'CIRCUITO_Materiais_2026/PROPOSTA DIDÁTICA/C360-4ºANO-PROPOSTA DIDÁTICA.pdf',
                    },
                    {
                        nome: 'C360-5ºANO-PROPOSTA DIDÁTICA',
                        arquivo: 'CIRCUITO_Materiais_2026/PROPOSTA DIDÁTICA/C360-5ºANO-PROPOSTA DIDÁTICA.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Sequência Didática',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'SD_Brincadeiras_1ano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_Brincadeiras_1ano.pdf',
                    },
                    {
                        nome: 'SD_Brincadeiras_2ano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_Brincadeiras_2ano.pdf',
                    },
                    {
                        nome: 'SD_Brincadeiras_3ano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_Brincadeiras_3ano.pdf',
                    },
                    {
                        nome: 'SD_CienciasHumanas_1ºano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_CienciasHumanas_1ºano.pdf',
                    },
                    {
                        nome: 'SD_CienciasHumanas_2ºano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_CienciasHumanas_2ºano.pdf',
                    },
                    {
                        nome: 'SD_CienciasHumanas_3ºano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_CienciasHumanas_3ºano.pdf',
                    },
                    {
                        nome: 'SD_CienciasNatureza_1ºano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_CienciasNatureza_1ºano.pdf',
                    },
                    {
                        nome: 'SD_CienciasNatureza_2ºano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_CienciasNatureza_2ºano.pdf',
                    },
                    {
                        nome: 'SD_CienciasNatureza_3ºano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_CienciasNatureza_3ºano.pdf',
                    },
                    {
                        nome: 'SD_Matematica_1ano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_Matematica_1ano.pdf',
                    },
                    {
                        nome: 'SD_Matematica_2ano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_Matematica_2ano.pdf',
                    },
                    {
                        nome: 'SD_Matematica_3ano',
                        arquivo: 'CIRCUITO_Materiais_2026/SEQUÊNCIA DIDÁTICA/SD_Matematica_3ano.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Teste Diagnóstico',
        materiais: [
            {
                isPaste: true,
                titlePaste: 'Língua Portuguesa',
                arquivos: [
                    {
                        nome: 'C360-LP-2ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-2ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-2ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-2ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-3ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-3ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-3ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-3ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-4ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-4ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-4ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-4ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-5ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-5ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-LP-5ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/C360-LP-5ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'Quadro-síntese-LP_3º ANO_C360',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/Quadro-síntese-LP_3º ANO_C360.pdf',
                    },
                    {
                        nome: 'Quadro-síntese-LP_4º ANO_C360',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/Quadro-síntese-LP_4º ANO_C360.pdf',
                    },
                    {
                        nome: 'Quadro-síntese-LP_5º ANO_C360.pdf',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/LÍNGUA PORTUGUESA/Quadro-síntese-LP_5º ANO_C360.pdf',
                    },
                ],
            },
            {
                isPaste: true,
                titlePaste: 'Matemática',
                arquivos: [
                    {
                        nome: 'C360-MAT-2ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-2ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-2ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-2ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-3ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-3ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-3ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-3ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-4ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-4ºANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-4ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-4ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-5ºANO-ORIENTACOES_TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-5ANO-ORIENTACOES_TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'C360-MAT-5ºANO-TESTE DIAGNÓSTICO',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/C360-MAT-5ºANO-TESTE DIAGNÓSTICO.pdf',
                    },
                    {
                        nome: 'Quadro-síntese-MAT_3º ANO_C360',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/Quadro-síntese-MAT_3º ANO_C360.pdf',
                    },
                    {
                        nome: 'Quadro-síntese-MAT_4º ANO_C360',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/Quadro-síntese-MAT_4º ANO_C360.pdf',
                    },
                    {
                        nome: 'Quadro-síntese-MAT_5º ANO_C360',
                        arquivo: 'CIRCUITO_Materiais_2026/TESTE DIAGNÓSTICO/MATEMÁTICA/Quadro-síntese-MAT_5 ANO_C360.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Textos - Anexos',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'ANEXO Ciclo 01 Circuito 360_texto_Modos de pensar e fazer um planejamento de sala de aula',
                        arquivo:
                            'CIRCUITO_Materiais_2026/TEXTOS - ANEXOS/ANEXO Ciclo 01 Circuito 360_texto_Modos de pensar e fazer um planejamento de sala de aula.pdf',
                    },
                    {
                        nome: 'ANEXO Ciclo 01 Circuito 360_texto_O dever de casa no processo de aprendizagem da língua escrita',
                        arquivo:
                            'CIRCUITO_Materiais_2026/TEXTOS - ANEXOS/ANEXO Ciclo 01 Circuito 360_texto_O dever de casa no processo de aprendizagem da língua escrita.pdf',
                    },
                ],
            },
        ],
    },
    {
        title: 'Visão Geral e Sistemática de Acompanhamento',
        materiais: [
            {
                arquivos: [
                    {
                        nome: 'Circuito 360 - Visao Geral',
                        arquivo: 'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Circuito 360 - Visao Geral.pdf',
                    },
                    {
                        nome: 'CIRCUITO_360_SISTEMATICA_DE_ACOMPANHAMENTO',
                        arquivo:
                            'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/CIRCUITO_360_SISTEMATICA_DE_ACOMPANHAMENTO.pdf',
                    },
                ],
                subPastas: [
                    {
                        titleSubPasta: 'Cartazes',
                        arquivos: [
                            {
                                nome: 'Cartazes_Circuito 360_A3_ACOMP. LIVROS LIDOS',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Cartazes/Cartazes_Circuito 360_A3_ACOMP. LIVROS LIDOS.pdf',
                            },
                            {
                                nome: 'Cartazes_Circuito360_ACOMPANHAMENTO MENSAL I A',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Cartazes/Cartazes_Circuito360_ACOMPANHAMENTO MENSAL I A.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Relatórios Qualitativos',
                        arquivos: [
                            {
                                nome: 'CIRCUITO_360_Relatorio_A',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/CIRCUITO_360_Relatorio_A.pdf',
                            },
                            {
                                nome: 'CIRCUITO_360_Relatorio_B',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/CIRCUITO_360_Relatorio_B.pdf',
                            },
                            {
                                nome: 'CIRCUITO_360_Relatorio_C',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Relatórios Qualitativos/CIRCUITO_360_Relatorio_C.pdf',
                            },
                        ],
                    },
                    {
                        titleSubPasta: 'Tabelas',
                        arquivos: [
                            {
                                nome: 'Circuito360_tabela_ACOMPANHAMENTO BIMESTRAL I',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_ACOMPANHAMENTO BIMESTRAL I.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_ACOMPANHAMENTO BIMESTRAL II',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_ACOMPANHAMENTO BIMESTRAL II.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_ACOMPANHAMENTO LIVROS LIDOS',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_ACOMPANHAMENTO LIVROS LIDOS.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_ACOMPANHAMENTO MENSAL I B',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_ACOMPANHAMENTO MENSAL I B.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_ACOMPANHAMENTO MENSAL II',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_ACOMPANHAMENTO MENSAL II.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_PERFIL TURMA I',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_PERFIL TURMA I.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_PERFIL TURMA II',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_PERFIL TURMA II.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_RESULTADO FINAL I',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_RESULTADO FINAL I.pdf',
                            },
                            {
                                nome: 'Circuito360_tabela_RESULTADO FINAL II',
                                arquivo:
                                    'CIRCUITO_Materiais_2026/VISÃO GERAL E SISTEMÁTICA DE ACOMPANHAMENTO/Tabelas/Circuito360_tabela_RESULTADO FINAL II.pdf',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
